<template>
  <!-- If navigating to a deep link, or any other auth error -->
  <template v-if="auth?.error">
    <div class="connect-error bg-teal">
      <div v-if="auth.error.startsWith('popup_window_error')">
        Please enable popups and refresh the page to login.
      </div>
      <div v-else>
        Please refresh the page to login.
        <div>{{ auth.error }}</div>
      </div>
    </div>
  </template>

  <template v-if="networkError">
    <div class="connect-error bg-teal">
      <div>
        Network error. Please contact your admin.
        <div>{{ networkError }}</div>
      </div>
    </div>
  </template>

  <slot />
</template>

<script setup lang="ts">
import { isEmployeeOnly } from "@/auth/auth.roles";
import { auth } from "@/stores/auth.store";
import { useUserStore } from "@/stores/user.store";
import { useFragment, UserMainFieldsFragmentDoc, UserOverviewFragmentDoc } from "owfsa-graphql";
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";

const userStore = useUserStore();
const router = useRouter();
const isAuthenticated = computed(() => auth?.account !== null);
const networkError = ref();

watch(
  [isAuthenticated, () => router.currentRoute.value.name, () => userStore.self],
  ([isAuth, routeName]) => {
    if (
      isAuth &&
      routeName === "home" &&
      userStore.userExists &&
      !userStore.isBlocked &&
      isEmployeeOnly()
    ) {
      router.replace({ name: "work-schedule" });
    }
  },
  { immediate: true },
);

watch(isAuthenticated, async (isAuth) => {
  if (isAuth) {
    const result = await userStore.getSelfQuery.executeQuery({
      requestPolicy: "network-only",
    });

    networkError.value = result.error?.value;
    // unwrap the fragment twice to get proper typing
    const userFrag = useFragment(UserMainFieldsFragmentDoc, result.data.value?.self);
    userStore.self = userFrag ? useFragment(UserOverviewFragmentDoc, userFrag) : null;
  } else {
    userStore.self = null;
  }
}, { immediate: true });
</script>

<style scoped>
.connect-error {
  margin-top: 48px;
  text-align: center;
  padding: 8px;
}
</style>
